const enum ModuleStorageKeys {
    DRIVER_SAFETY_STORAGE_KEY = "@store_driverSafety",
    INSPECTION_STORAGE_KEY = "@store_inspection",
    COACHING_STORAGE_KEY = "@store_coaching",
    HOS_DISPLAY_PREFERENCES_STORAGE_KEY = "@store_hosDisplayPreferences"
    // OTHER_MODULE_STORAGE_KEY = "@store_otherModule"
    // OTHER_OTHER_MODULE_STORAGE_KEY = "@store_otherOtherModule"
    // ...
}

export default ModuleStorageKeys;
